export default function Services() {
  const services = [
    {
      icon: 'ri-roadster-line',
      title: 'Driveways',
      description: 'Custom driveway installation and repair using premium materials. We create durable, attractive driveways that enhance your home\'s curb appeal and withstand heavy use for years to come.',
      features: ['Asphalt Paving', 'Concrete Installation', 'Paver Driveways', 'Resurfacing']
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Patios',
      description: 'Beautiful outdoor living spaces designed for relaxation and entertainment. Our expert team builds stunning patios that seamlessly blend with your landscape and lifestyle needs.',
      features: ['Stone Patios', 'Brick Pavers', 'Stamped Concrete', 'Custom Designs']
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Porches',
      description: 'Welcoming front and back porches that add charm and functionality to your home. We design and build porches that create the perfect space for relaxing and greeting guests.',
      features: ['Front Porches', 'Back Porches', 'Covered Designs', 'Custom Railings']
    },
    {
      icon: 'ri-plant-line',
      title: 'Flower Beds',
      description: 'Elegant hardscape borders and raised flower beds that add structure and beauty to your garden. We create functional designs that protect your plants while enhancing your landscape aesthetics.',
      features: ['Retaining Walls', 'Edging Solutions', 'Raised Beds', 'Garden Borders']
    },
    {
      icon: 'ri-building-line',
      title: 'Walkways',
      description: 'Safe and stylish pathways connecting different areas of your property. Our walkways combine functionality with aesthetic appeal, using materials that complement your existing hardscape.',
      features: ['Stone Pathways', 'Paver Walks', 'Stepping Stones', 'Lighted Paths']
    },
    {
      icon: 'ri-stack-line',
      title: 'Retaining Walls',
      description: 'Structural and decorative walls that prevent erosion while adding dimension to your landscape. We engineer walls that are both beautiful and built to last through all weather conditions.',
      features: ['Block Walls', 'Stone Walls', 'Terracing', 'Erosion Control']
    },
    {
      icon: 'ri-landscape-line',
      title: 'Backyard Makeovers',
      description: 'Complete backyard transformations that turn ordinary spaces into extraordinary outdoor retreats. From concept to completion, we create cohesive designs that maximize your yard\'s potential.',
      features: ['Full Redesigns', 'Outdoor Kitchens', 'Fire Pits', 'Seating Areas']
    },
    {
      icon: 'ri-tools-line',
      title: 'Repairs & Maintenance',
      description: 'Professional restoration and upkeep services to keep your hardscape looking its best. From crack repair to complete resurfacing, we extend the life of your outdoor investments.',
      features: ['Crack Repair', 'Sealing', 'Cleaning', 'Restoration']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-purple-600">Services</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Comprehensive hardscape solutions tailored to your needs. From design to installation, we handle every aspect of your outdoor project with expertise and care.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green-100 rounded-lg mb-4 sm:mb-6">
                <i className={`${service.icon} text-2xl sm:text-3xl text-green-600`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-xs sm:text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-white rounded-2xl shadow-xl p-6 sm:p-10 md:p-12 border border-gray-100">
          <div className="text-center mb-10">
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Pricing <span className="text-green-600">Guide</span>
            </h3>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Transparent pricing to help you plan your project
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-green-50 to-purple-50 rounded-xl p-6 sm:p-8 md:p-10 border-2 border-green-200">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex-1 text-center md:text-left">
                  <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-green-600 rounded-lg flex-shrink-0">
                      <i className="ri-price-tag-3-line text-xl sm:text-2xl text-white"></i>
                    </div>
                    <h4 className="text-xl sm:text-2xl font-bold text-gray-900">Interlock Paving</h4>
                  </div>
                  <p className="text-base sm:text-lg text-gray-700 mb-2">
                    Starting at <span className="text-2xl sm:text-3xl font-bold text-green-600">$14</span> per sq ft
                  </p>
                  <p className="text-sm sm:text-base text-gray-600">
                    Final pricing varies based on stone type and project complexity
                  </p>
                </div>
                <div className="flex-shrink-0 w-full md:w-auto">
                  <button 
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) {
                        const offset = 80;
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - offset;
                        window.scrollTo({
                          top: offsetPosition,
                          behavior: 'smooth'
                        });
                      }
                    }}
                    className="bg-gradient-to-r from-green-600 to-purple-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:from-green-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer text-base sm:text-lg w-full md:w-auto"
                  >
                    Get Your Quote
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-8 grid sm:grid-cols-3 gap-4 sm:gap-6">
              <div className="text-center p-4 sm:p-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-purple-100 rounded-full mx-auto mb-4">
                  <i className="ri-stack-line text-xl sm:text-2xl text-purple-600"></i>
                </div>
                <h5 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Stone Type</h5>
                <p className="text-sm sm:text-base text-gray-600">Premium materials may increase cost</p>
              </div>
              <div className="text-center p-4 sm:p-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-ruler-2-line text-xl sm:text-2xl text-green-600"></i>
                </div>
                <h5 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Project Size</h5>
                <p className="text-sm sm:text-base text-gray-600">Larger projects may qualify for better rates</p>
              </div>
              <div className="text-center p-4 sm:p-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-purple-100 rounded-full mx-auto mb-4">
                  <i className="ri-settings-3-line text-xl sm:text-2xl text-purple-600"></i>
                </div>
                <h5 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Complexity</h5>
                <p className="text-sm sm:text-base text-gray-600">Custom designs and patterns affect pricing</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-purple-600 to-purple-700 rounded-2xl p-6 sm:p-8 md:p-12 text-center text-white">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4">Need a Custom Solution?</h3>
          <p className="text-base sm:text-lg mb-6 text-white/90 max-w-2xl mx-auto px-4">
            Every project is unique. Contact us to discuss your specific hardscape needs and get a personalized quote for your dream outdoor space.
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }}
            className="bg-white text-purple-600 px-6 sm:px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-base sm:text-lg"
          >
            Request Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
